import { CasesTableProvider } from '../contexts'
import { CasesPage } from '../page'

export const ActiveCasesPage = () => {
  return (
    <CasesTableProvider value={{ tableType: 'active' }}>
      <CasesPage />
    </CasesTableProvider>
  )
}
